var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingBox"},[_c('van-loading',{attrs:{"type":"spinner","size":"24px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }